import { useEffect } from 'react';

const META_DEFINITIONS = [
  ['meta[name="description"]', { name: 'description' }],
  ['meta[property="og:title"]', { property: 'og:title' }],
  ['meta[property="og:description"]', { property: 'og:description' }],
  ['meta[name="twitter:title"]', { name: 'twitter:title' }],
  ['meta[name="twitter:description"]', { name: 'twitter:description' }],
];

function upsertMeta(selector, attributes, content) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

function PageMeta({ title, description }) {
  useEffect(() => {
    document.title = title;

    META_DEFINITIONS.forEach(([selector, attributes]) => {
      upsertMeta(selector, attributes, attributes.name === 'description' || attributes.property === 'og:description'
        || attributes.name === 'twitter:description'
        ? description
        : title);
    });
  }, [description, title]);

  return null;
}

export default PageMeta;
